import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {NGXLogger} from 'ngx-logger';
import {Observable} from 'rxjs/Observable';
import {AdminRefundDisburseModel} from './admin-refund-disburse-entry/admin-refund-disburse-model';
import * as endpoints from './report.endpoints';
import {ReportDownloadModel} from './reporting.configuration';
import {ChallanNameRequest} from "./challan-transaction-data/challan-transaction";
import {BILLER_TRANSITION_DATA_REPORT_CSV, EMI_DETAILED_TRANSACTION_PDF, SYNDICATE_TRANSACTION_DATA_REPORT} from './report.endpoints';

import {BILLER_TRANSITION_REPORT_PDF} from "./report.endpoints";

@Injectable()
export class ReportingService {
  constructor(
    private http: HttpClient,
    private logger: NGXLogger) {
  }

  getAdminTrxnsReport(adminReport): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/txns-data/view', adminReport, {observe: 'response'});
  }

  getPgUnprocessedTransaction(adminReport): Observable<any> {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post(endpoints.PG_UNPROCESSED_TRANSACTION, adminReport);
  }

  getAdminTrxnsReportDownloadCsv(adminReport): Observable<any> {
    return this.http.post<any>(
      '/honcho/api/reports/admin/txns-data/download-csv', adminReport);
  }

  getAdminTrxnsReportDownloadExcel(adminReport): Observable<any> {
    return this.http.post<any>(
      '/honcho/api/reports/admin/txns-data/download-excel', adminReport);
  }

  getUnprocessedTransactionReportDownloadCsv(pgUnprocessedReportVM): Observable<ReportDownloadModel> {
    return this.http.post<any>(
      endpoints.PG_UNPROCESSED_TRANSACTION_CSV,
      pgUnprocessedReportVM);
  }

  getPGTransactionReportDownloadCsv(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_TRANSACTION_CSV, options);
  }

  getPGTransactionReportDownloadExcel(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_TRANSACTION_EXCEL, options);
  }

  getPGAutoDebitTransactionReportDownloadCsv(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_AUTO_DEBIT_TRANSACTION_CSV, options);
  }

  updateBillPaidStatus(urlQueryParam): Observable<any> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.post<any>(endpoints.UPDATE_BILL_PAID_STATUS, {}, options);
  }

  updatePaymentStatus(urlQueryParam): Observable<any> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.post<any>(endpoints.UPDATE_PAYMENT_STATUS, {}, options);
  }

  updatePGTransactionStatus(urlQueryParam): Observable<any> {
    const options = { params: new HttpParams({ fromObject: urlQueryParam }) };
    return this.http.post<any>(endpoints.UPDATE_PG_TRANSACTION_STATUS, {}, options);
  }

  getPGTransactionReportDownloadPdf(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_TRANSACTION_PDF, options);
  }

  getEmiTransactionReportDownloadPdf(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.EMI_DETAILED_TRANSACTION_PDF, options);
  }


  getPGAutoDebitTransactionReportDownloadPdf(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_AUTO_DEBIT_TRANSACTION_PDF, options);
  }

  bkashRefundDelete(urlQueryParam): Observable<any> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.delete<any>(endpoints.BKASH_REFUND_DELETE, options);
  }

  disburseDelete(urlQueryParam): Observable<any> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.delete<any>(endpoints.DISBURSE_DELETE, options);
  }

  getAdminTrxnsReportDownloadPdf(adminReport): Observable<any> {
    return this.http.post<any>(
      '/honcho/api/reports/admin/txns-data/download-pdf',
      adminReport);
  }

  saveRefundDisburse(refundDisburseData: AdminRefundDisburseModel): Observable<any> {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/insert-refund-disburse', refundDisburseData, {observe: 'response'});
  }

  getBillPaymentHistoryList(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get('/honcho/api/challan/name-change-history', options);
  }

  changeChallanName(challanNameRequest: ChallanNameRequest): Observable<any> {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/challan/change-applicant-name', challanNameRequest, {observe: 'body'});
  }

  getAdminTrxnsSummaryReport(adminReport): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/txns-summary/view', adminReport, {observe: 'response'});
  }

  getMerchantChallanSummaryReport(merchantChallan): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/challan-summary/view', merchantChallan, {observe: 'response'});
  }

  getBillerTrxnsDataReport(billerData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/biller/txns-data/view', billerData, {observe: 'response'});
  }

  getBillerTrxnsSummaryReport(billerData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/biller/txns-summary/view', billerData, {observe: 'response'});
  }

  getMerchantTrxnsDataReport(merchantData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/txns-data/view', merchantData, {observe: 'response'});
  }

  getMerchantTrxnsSummaryReport(merchantData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/txns-summary/view', merchantData, {observe: 'response'});
  }

  getChallanTrxnsDataReport(challanData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/challan/txns-data/view', challanData, {observe: 'response'});
  }

  getAllMerchantWithChallan(): any {
    //this.logger.debug('calling challan-merchant-user api from ReportingService.....  ');
    return this.http.get('/honcho/api/reports/get/challan-merchant-user', {observe: 'response'});
  }

  getBankTrxnsDataReport(bankData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/bank/txns-data/view', bankData, {observe: 'response'});
  }

  getBankTrxnsSummaryReport(bankData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/bank/txns-summary/view', bankData, {observe: 'response'});
  }

  getGatewayTrxnsDataReport(gatewayData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/gateway/detailed-trans-report', gatewayData, {observe: 'response'});
  }

  getGatewayTrxnsSummaryReport(gatewayData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/gateway/summary-trans-report', gatewayData, {observe: 'response'});
  }

  getSyndicateTrxnsDataReport(syndicateData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/syndicate/txns-data/view', syndicateData, {observe: 'response'});
  }

  getSyndicateTrxnsSummaryReport(syndicateData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/syndicate/txns-summary/view', syndicateData, {observe: 'response'});
  }

  getAdminDisputeRaisedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/dispute-raised-summary/view', disputeData, {observe: 'response'});
  }

  getAdminDisputeAssignedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/dispute-assigned-summary/view', disputeData, {observe: 'response'});
  }

  getBillerDisputeAssignedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/biller/dispute-assigned-summary/view', disputeData, {observe: 'response'});
  }

  getBillerDisputeRaisedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/biller/dispute-raised-summary/view', disputeData, {observe: 'response'});
  }

  getBankDisputeAssignedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/bank/dispute-assigned-summary/view', disputeData, {observe: 'response'});
  }

  getBankDisputeRaisedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/bank/dispute-raised-summary/view', disputeData, {observe: 'response'});
  }

  getMerchantDisputeAssignedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/dispute-assigned-summary/view', disputeData, {observe: 'response'});
  }

  getMerchantDisputeRaisedSummaryReport(disputeData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/dispute-raised-summary/view', disputeData, {observe: 'response'});
  }

  getNotificationReport(notificationData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/notification-report', notificationData, {observe: 'response'});
  }

  getAdminAgentPerfrmnReport(notificationData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/agent-performance-report', notificationData, {observe: 'response'});
  }

  getAccountStatementReport(merchantData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/account-statements/view', merchantData, {observe: 'response'});
  }

  getRechargeHistoryReport(syndicateData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/syndicate/bucket-recharge-history/view', syndicateData, {observe: 'response'});
  }

  getPGTransactionReport(pgData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post(endpoints.PG_DETAILED_TRANSACTION_DATA, pgData);
  }

  getPGAutoDebitTransactionReport(pgData): any {
    //this.logger.debug('calling post api from ReportingService for AutoDebit.....');
    return this.http.post(endpoints.PG_DETAILED_AUTO_DEBIT_TRANSACTION_DATA, pgData);
  }

  getDisputeList(fromDate, toDate): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/dispute-list/view?fromDate=' + fromDate + '&toDate=' + toDate, {observe: 'response'});
  }

  getRefundListByDates(fromDate, toDate): any {
    //this.logger.debug('calling getRefundListByDates post api from ReportingService.....');
    return this.http.post('/honcho/api/refund/list-by-datet?fromDate=' + fromDate + '&toDate=' + toDate, {observe: 'response'});
  }


  getDescoPrepaidReconciliationByDates(pgData): any {
    //this.logger.debug('calling post api from ReportingService for DescoPrepaidReconciliationByDates');
    return this.http.post('/honcho/api/reports/desco-prepaid-reconciliation', pgData, {observe: 'response'});
  }

  getRefundRequestListByDates(fromDate, toDate): any {
    //this.logger.debug('calling  get api from ReportingService for RefundRequestListByDates');
    return this.http.get('/honcho/api/reports/refund-request-list?fromDate=' + fromDate + '&toDate=' + toDate, {observe: 'response'});
  }

  updateRefundRequestStatus(pgData): any {
    //this.logger.debug('Data : ', pgData);
    //this.logger.debug('calling post api from ReportingService for to updateRefundRequestStatus');
    return this.http.post('/honcho/api/reports/refund-request-update-status', pgData, {observe: 'response'});
  }


  bkashRefundRequest(pgData): any {
    //this.logger.debug('calling post api from ReportingService for bkash Refund Request.....');
    return this.http.post('/honcho/api/refund/save-refund-trnx', pgData, {observe: 'response'});
  }

  disbursementRequest(pgData): any {
    //this.logger.debug('calling post api from ReportingService for bkash Refund Request.....');
    return this.http.post('/honcho/api/refund/save-disbursement', pgData, {observe: 'response'});
  }

  payoutRequest(pgData): any {
    //this.logger.debug('calling post api from ReportingService for bkash Refund Request.....');
    return this.http.post('/honcho/api/refund/b2c-payout', pgData, {observe: 'response'});
  }

  transferRequest(pgData): any {
    //this.logger.debug('calling post api from ReportingService for bkash Refund Request.....');
    return this.http.post('/honcho/api/refund/intra-account-transfer', pgData, {observe: 'response'});
  }

  getDisbursementList(vm): any {
    //this.logger.debug('calling post api from ReportingService for load Bkash Refund Transacions.....');
    return this.http.post('/honcho/api/refund/list-disbursement', vm);
  }

  checkRefundStatus(trxID): any {
    //this.logger.debug('calling post api from ReportingService for bkash check Refund Status.....');
    return this.http.post('/honcho/api/refund/bkash-transaction-status?trxID=' + trxID, {observe: 'response'});
  }

  checkBKashWalletBalance(): any {
    //this.logger.debug('calling post api from ReportingService for bkash check Refund Status.....');
    return this.http.post('/honcho/api/refund/check-bKash-wallet-balance', {observe: 'response'});
  }

  bkashRefundConfirmCall(pgData): any {
    //this.logger.debug('calling post api from ReportingService for bkash Refund Confirm Call.....');
    return this.http.post('/honcho/api/refund/bkash-trnsaction', pgData, {observe: 'response'});
  }

  loadBkashRefundTransacions(vm): any {
    //this.logger.debug('calling post api from ReportingService for load Bkash Refund Transactions.....');
    return this.http.post('/honcho/api/refund/list', vm);
  }

  getPGTransactionSummaryReport(pgData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/payment-txns-summary/view', pgData, {observe: 'response'});
  }

  getPMTransactionData(pmData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    // return this.http.post("http://localhost:8081/report/date",pmData,{ observe: 'response' });
    return this.http.post('https://pg.ekpay.gov.bd/donation/report/date', pmData, {observe: 'response'});
  }

  getAdvancedSearchData(input_user): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/advanced-search-data/view', input_user, {observe: 'response'});
  }

  getEkdeshTransactionData(pmData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    //return this.http.post("http://localhost:8081/report/date",pmData,{ observe: 'response' });
    return this.http.post('https://sadmin.ekpay.gov.bd/donation/report/date', pmData, {observe: 'response'});
  }

  getProfitReports(profitData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/profit-report', profitData, {observe: 'response'});
  }

  getProfitSummaryReports(profitData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/profit-summary-report', profitData, {observe: 'response'});
  }

  getDisputeReports(profitData, userType): any {
    //this.logger.debug('calling post api from ReportingService.....');
    if (userType == 'Biller') {
      return this.http.post('/honcho/api/reports/biller/dispute-report', profitData, {observe: 'response'});
    } else if (userType == 'Merchnat') {
      return this.http.post('/honcho/api/reports/merchant/dispute-report', profitData, {observe: 'response'});
    } else if (userType == 'Syndicate') {
      return this.http.post('/honcho/api/reports/syndicate/dispute-report', profitData, {observe: 'response'});
    } else if (userType == 'DMS User') {
      return this.http.post('/honcho/api/reports/dms/dispute-report', profitData, {observe: 'response'});
    } else {
      return this.http.post('/honcho/api/reports/admin/dispute-report', profitData, {observe: 'response'});
    }
  }

  getComplaintDetailsReport(profitData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/grs/complaint-detailed-report', profitData, {observe: 'response'});
  }

  getComplaintSummaryReport(profitData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/grs/complaint-summary-report', profitData, {observe: 'response'});
  }

  getSettlementReport(settlementObj): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/admin/settlement-report', settlementObj, {observe: 'response'});
  }

  getMerchantQrCodeWiseTrxnsDataReport(merchantData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/qrcode-wise-txns-data/view', merchantData, {observe: 'response'});
  }

  getPGQrCodeTransactionReport(pgData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post(endpoints.PG_DETAILED_QRCODE_TRANSACTION_DATA, pgData);
  }

  getPGQrCodeTransactionReportDownloadCsv(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_QRCODE_TRANSACTION_CSV, options);
  }

  getPGQrCodeTransactionReportDownloadPdf(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_QRCODE_TRANSACTION_PDF, options);
  }

  getPGQrCodeTransactionReportDownloadExcel(urlQueryParam): Observable<ReportDownloadModel> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get<any>(endpoints.PG_DETAILED_QRCODE_TRANSACTION_EXCEL, options);
  }

  getPGEmiTransactionReport(pgData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post(endpoints.PG_DETAILED_EMI_TRANSACTION_DATA, pgData);
  }

  updateEmiDetailHistoryStatus(urlQueryParam): Observable<any> {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.post<any>(endpoints.UPDATE_EMI_TRANSACTION_STATUS, {}, options);
  }

  getMerchantEmiWiseTrxnsDataReport(merchantData): any {
    //this.logger.debug('calling post api from ReportingService.....');
    return this.http.post('/honcho/api/reports/merchant/emi-wise-txns-data/view', merchantData, {observe: 'response'});
  }


  getBillerTransactionData(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.BILLER_TRANSACTION_DATA, options);
  }

  getBillerReportCsv(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.BILLER_TRANSITION_DATA_CSV, options);
  }

  getBillerTransitionExcel(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    // return this.http.get(endpoints.BILLER_TRANSITION_DATA_REPORT, options);
    return this.http.get(endpoints.BILLER_TRANSACTION_REPORT_EXCEL, options);
  }

  getBillerTransitionDataReportPDF(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    // return this.http.get(endpoints.BILLER_TRANSITION_DATA_REPORT_PDF, options);
  }
  getBillerTransactionReportPDF(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    // return this.http.get(endpoints.BILLER_TRANSITION_DATA_REPORT_PDF, options);
    return this.http.get(endpoints.BILLER_TRANSITION_REPORT_PDF, options);
  }

  getBillerTransitionDataReportCSV(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.BILLER_TRANSITION_DATA_REPORT_CSV, options);
  }

  getSyndicateTransitionDataReport(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.SYNDICATE_TRANSACTION_DATA_REPORT, options);
  }

  getSyndicateTrxReportCsv(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.SYNDICATE_TRANSACTION_REPORT_CSV, options);
  }

  getSyndicateTransactionData(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.SYNDICATE_TRANSACTION_DATA, options);
  }

  getBillPaymentHistoryInfoList(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.BILL_TRANSITION_INFO, options);
  }

  getBillPaymentHistoryReport(urlQueryParam: any): any {
    const options = {params: new HttpParams({fromObject: urlQueryParam})};
    return this.http.get(endpoints.BILL_TRANSITION_REPORT, options);
  }

  getViewMerchant(): any {
    return this.http.get('/honcho/api/merchant/view?merchant_id=all&mode=web', {observe: 'response'});
  }


  getReconciliation(fromDate: string, toDate: string, merchantName?: string): any {
    let url = `/honcho/api/reports/admin/reconciliation-list/view?fromDate=${fromDate}&toDate=${toDate}`;
    if (merchantName) {
      url += `&merchantName=${merchantName}`;
    }
    return this.http.post(url, {observe: 'response'});
  }

  reconcileUnprocessedTransactions(payload: { ekpayTransactionIdList: string[] }): any {
    return this.http.post('honcho/api/reconcillation/reconciliation-list', payload, {observe: 'response'});
  }

}



// WEBPACK FOOTER //
// ./src/app/report/reporting.service.ts